export default "__VITE_ASSET__CrYkCChY__"